import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Menu, MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ApiService } from '@core/providers/http';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import {
  BolsaService,
  BolseiroService,
  CommunicationService,
  InstituicaoEnsinoService,
  MunicipioService,
  PaisService,
  ProvinciaService,
  UtilizadorService,
} from '../../api/services';
import { Bolsa, Bolseiro, FilterItem } from '../../api/models';
import { Subscription } from 'rxjs';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { EstadoBolsaPipe } from '@app/features-modules/gestao-bolseiros/pipes/estado-bolsa.pipe';
import { NivelAcademicoPipe } from '@app/features-modules/gestao-bolseiros/pipes/nivel-academico.pipe';
import { ComprovativoSubsidioModalComponent } from '../comprovativo-subsidio-modal/comprovativo-subsidio-modal.component';
import {
  TableColumn,
  TableComponent,
} from '@app/shared/components/table/table.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { DialogModule } from 'primeng/dialog';
import { FormGroup, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-home-auxilio-formacao',
  imports: [
    CommonModule,
    ButtonModule,
    TagModule,
    MenuModule,
    ToastModule,
    ConfirmDialogModule,
    PaginatorControlComponent,
    EstadoBolsaPipe,
    NivelAcademicoPipe,
    ComprovativoSubsidioModalComponent,
    TableComponent,
    SearchBarComponent,
    DataVoidComponent,
    BackButtonComponent,
    DialogModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
  ],
  providers: [
    ApiService,
    ConfirmationService,
    DialogService,
    MessageService,
    BolseiroService,
    BolsaService,
    CommunicationService,
    UtilizadorService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    InstituicaoEnsinoService,
  ],
  templateUrl: './home-auxilio-formacao.component.html',
  styleUrls: ['./home-auxilio-formacao.component.scss'],
  standalone: true,
})
export class HomeAuxilioFormacaoComponent implements OnInit, OnDestroy {
  filtersOutput: { [key: string]: any } = {};
  router = inject(Router);
  dialogService = inject(DialogService);
  messageService = inject(MessageService);

  paises: any[] = [];
  auxilioCounts: any;
  provincias: any[] = [];
  municipios: any[] = [];
  tipoBolsaList: any[] = [];
  isLoading: boolean = false;
  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];
  estados = [
    { id: 1, designacao: 'Activo' },
    { id: 2, designacao: 'Inactivo' },
  ];

  tipoBolsaOptions: any[] = [
    { id: 1, designacao: 'Interna' },
    { id: 2, designacao: 'Externa' },
  ];

  niveisAcademicos = [
    { label: 'Ensino Primário', id: 1 },
    { label: 'Ensino Primário (1º Ciclo)', id: 2 },
    { label: 'Ensino Primário (2º Ciclo)', id: 3 },
    { label: 'Bacharelato', id: 4 },
    { label: 'Licenciatura', id: 5 },
    { label: 'Pós-graduação', id: 6 },
    { label: 'Mestrado', id: 7 },
    { label: 'Doutoramento (PhD)', id: 8 },
    { label: 'Pós-doutoramento', id: 9 },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'BolseiroID',
      placeholder: 'Pesquise por nome',
    },
    {
      type: 'dropdown',
      controlName: 'TipoBolsaID',
      placeholder: 'Tipo de bolsa',
      options: this.tipoBolsaOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'NivelAcademico',
      placeholder: 'Grau Académico',
      options: this.niveisAcademicos,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoBolsa',
      placeholder: 'Estado',
      options: this.estados,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  pagination: Pagination<any> = new Pagination<any>();
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  bolsaService = inject(BolsaService);
  bolsas: any[] = [];
  bolsa: Bolsa[] = [];
  paginatedBolsas: Bolsa[] = [];
  @Input() bolsaID!: string;
  totalRecords: number = 0;
  first: number = 0;
  rows: number = 5;
  showFilters: boolean = false;
  showFilter: boolean = false;
  form!: FormGroup;

  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  utilizadores: any[] = [];

  constructor(private fb: FormBuilder) {}

  private subscriptions = new Subscription();

  actions: MenuItem[] = [
    {
      label: 'Detalhes',
      icon: 'pi pi-info-circle',
      command: ($event: any) => this.callRouteDetailsBolseiro($event.item.data),
    },
    // {
    //   label: 'Editar',
    //   icon: 'pi pi-pencil',
    //   command: ($event: any) => this.callRouteEditBolseiro($event.item?.data),
    // },
    // {
    //   label: 'Eliminar',
    //   icon: 'pi pi-trash',
    //   command: ($event: any) => this.deleteBolseiro(bolsa),
    // },
    // {
    //   label: 'Ficha de cadastro',
    //   icon: 'pi pi-download',
    //   command: ($event: any) => this.gerarComprovativo(Number($event.item?.data?.id)),
    // },
    // {
    //   label: 'Baixar Memorando',
    //   icon: 'pi pi-download',
    //   command: ($event: any) => this.gerarMemorando(Number($event.item?.data?.id)),
    // },
    // {
    //   label: 'Comprovativo subsídio preenchido',
    //   icon: 'pi pi-download',
    //   command: () => this.openComprovativoSubsidioModal(),
    // }
  ];
  @ViewChild('menu') menu!: Menu;

  // columns: TableColumn[] = [
  //   { field: 'bolseiro.nome', header: 'Estudante' },
  //   { field: 'nomeRequerente', header: 'Requerente', type: 'text', tooltip: 'Requerente' },
  //   { field: 'tipoBolsaDescricao', header: 'Tipo', type: 'text', tooltip: 'Tipo de Bolsa' },
  //   {
  //     field: 'areaProgramaFormacao.areaFormacao.designacao',
  //     header: 'Área de Formação',
  //     type: 'text',
  //     tooltip: 'Área de Formação',
  //   },
  //   {
  //     field: 'areaProgramaFormacao.programaFormacao.nome',
  //     header: 'Programa de Formação',
  //     type: 'text',
  //     tooltip: 'Programa de Formação',
  //   },
  //   { field: 'nivelAcademicoDescricao', header: 'Grau Académico', type: 'text', tooltip: 'Grau Académico' },
  //   { field: 'pais', header: 'País de Estudo', type: 'text', tooltip: 'País' },
  //   {
  //     field: 'estadoBolsaDescricao',
  //     header: 'Estado',
  //     type: 'tag',
  //     severityField: 'estadoBolsa',
  //     tagSeverityFunction: (rowData: any) => this.getSeverity(rowData.estadoBolsaDescricao),
  //     tooltip: 'Estado da Bolsa'
  //   }
  // ];

  columns: TableColumn[] = [
    {
      field: 'bolseiro.nome',
      header: 'Estudante',
      type: 'text',
      tooltip: 'Estudante',
    },
    // {
    //   field: 'nomeRequerente',
    //   header: 'Requerente',
    //   type: 'text',
    //   tooltip: 'Requerente',
    // },
    {
      field: 'tipoBolsaDescricao',
      header: 'Tipo',
      type: 'text',
      tooltip: 'Tipo de Bolsa',
    },
    { field: 'pais', header: 'País de Estudo', type: 'text', tooltip: 'País' },
    {
      header: 'Fase de formação',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.fase ?? '—',
    },
    {
      header: 'Curso',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.curso ?? '—',
    },
    {
      header: 'Ano curricular',
      type: 'text',
      valueGetter: (r: any) => r?.matricula?.[0]?.anoCurricular ?? '—',
    },
    {
      header: 'Instituição de Ensino',
      type: 'text',
      valueGetter: (r: any) => {
        const m = r?.matricula?.[0];
        const inst = m?.instituicaoEnsino?.trim();
        const uo = m?.unidadeOrganica?.trim();
        return [inst, uo].filter(Boolean).join(' - ') || '—';
      },
      tooltip: 'Instituição + Unidade Orgânica',
    },
    {
      field: 'estadoBolsaDescricao',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoBolsa',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.estadoBolsaDescricao),
      tooltip: 'Estado da Bolsa',
    },
  ];

  toggleMenu(event: Event) {
    this.menu.toggle(event);
  }

  ngOnInit(): void {
    this.loadAllBolsa({});
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );

    this.form = this.fb.group({
      BolseiroID: [null],
      TipoBolsaID: [null],
      NivelAcademico: [null],
      EstadoBolsa: [null],
    });
  }

  callRouteEditBolseiro(bolseiro: Bolseiro) {}

  callRouteDetailsBolseiro(bolseiro: Bolsa) {
    if (bolseiro && bolseiro.id) {
      this.router.navigate([
        `gestao-bolseiros/auxilio-formacao/detalhes-auxilio-formacao/${bolseiro.id}`,
      ]);
    }
  }

  public gerarComprovativo(id: number) {
    this.bolsaService.exportComprovativo(id).subscribe((response) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Comprovativo.pdf';
      document.body.appendChild(a);
      a.click();
      console.log('Comprovativo gerado com sucesso');
    });
  }

  openComprovativoSubsidioModal() {
    const ref = this.dialogService.open(ComprovativoSubsidioModalComponent, {
      showHeader: false,
      width: '35%',
    });

    ref.onClose.subscribe(() => {
      console.log('Comprovativo de subsídio gerado com sucesso');
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filters']) {
      this.loadAllBolsa(changes['filters'].currentValue);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  loadAllBolsa(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: 'id desc',
    };
    this.bolsaService.list({ ...params, BolsaID: this.bolsaID }).subscribe(
      (response) => {
        this.pagination = new Pagination<any>().deserialize(response);
        this.auxilioCounts = this.pagination?.records;
      },
      (error) => {
        console.error('Erro ao carregar bolsa:', error);
      }
    );
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Activo':
        return 'success';
      case 'Inactivo':
        return 'warn';
      case 'Suspenso':
        return 'danger';
      case 'Finalizado':
        return 'success';
      case 'Pendente':
        return 'info';
      default:
        return 'warn';
    }
  }

  transformNivelAcademico(nivel: string): string {
    // Implement your transformation logic here
    return nivel;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllBolsa();
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  handleFormValueChange(formValue: any) {
    this.filtersOutput = formValue;
    this.loadAllBolsa(formValue);
    this.showFilter = false; // Close the filter modal after applying filters
  }

  callRouteCreateBolseiro() {
    setTimeout(() => {
      this.router.navigate([
        'gestao-bolseiros/auxilio-formacao/cadastrar-auxilio-formacao',
      ]);
    }, 1000);
  }

  editBolseiro(bolseiro: Bolseiro) {}

  deleteBolseiro(bolseiro: Bolseiro) {}

  showFilterModal() {
    this.showFilter = true;
  }
}
